import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { get } from "../../../utils/request";
import "./style.css";
import "../../../index.css";
class PwSet extends Component {
  constructor(props) {
    super(props);
    this.state = {
      css: {},
    };
  }
  componentDidMount() {
    this.fixCss();
  }
  render() {
    return (
      <div
        style={{
          minHeight: this.state.css.minHeight,
          backgroundColor: "#e7e7e7",
        }}
        className="pws_box"
      >
        <NavLink
          to="/user/reset"
          className="pws_link_box pws_border_bottom_line major_top_5"
        >
          <div className="fl major_left_20">忘记密码</div>
          <div className="fr my_arrows">
            <img alt="" src={require("../../../images/article/more.png")}></img>
          </div>
        </NavLink>
        <NavLink to="/user/mpw" className="pws_link_box">
          <div className="fl major_left_20">修改密码</div>
          <div className="fr my_arrows">
            <img alt="" src={require("../../../images/article/more.png")}></img>
          </div>
        </NavLink>
        <div onClick={() => this.requestLogout()} className="pws_logout_box">
          退出登录
        </div>
      </div>
    );
  }

  requestLogout = () => {
    get("/public/v1/user/logout").then((res) => {
      if (res.status === "success") {
        window.location.href =
          window.location.protocol + "//" + window.location.host;
      }
    });
  };
  fixCss = () => {
    let minHeight = window.innerHeight;
    this.setState({
      css: {
        minHeight: minHeight,
      },
    });
  };
}

export default PwSet;



// WEBPACK FOOTER //
// ./src/containers/My/PwSet/index.js